import { EnquirySummary } from "@/models/enquiry/enquiry-summary.model";
import { IZoneEnquirySummary } from "@/models/interfaces/enquiry/zone-enquiry-summary-model.interface";

export class ZoneEnquirySummary extends EnquirySummary implements IZoneEnquirySummary {
    public code: string;

    constructor(code: string = "") {
        super();
        this.code = code;
    }
}
